import { useSrpContext } from '@/src/contexts'
import { resolveDynamicDepartDate } from '@/src/utils/srp/searchUtils'
import { useSearchParams } from 'next/navigation'

export const useGetSearchParamsObj = (): { urlQueryObj: Record<string, string>; isSeoQuery: boolean } => {
    const {
        SEOSrpData: { searchQuery: seoQuery }
    } = useSrpContext()
    const searchParams = useSearchParams()
    const rawQueryObj = seoQuery
        ? (seoQuery as unknown as Record<string, string>)
        : Object.fromEntries(searchParams.entries())



    // Dynamic (CMS) one-way links can arrive without a depart_date, optionally with a `dx`
    // offset instead. Resolve it here so the search query, the header and the date carousel
    // all read the same date.
    const dynamicDepartDate = resolveDynamicDepartDate(rawQueryObj)
    const urlQueryObj = dynamicDepartDate ? { ...rawQueryObj, depart_date: dynamicDepartDate } : rawQueryObj

    return {
        urlQueryObj,
        isSeoQuery: !!seoQuery
    }
}
